import { GROUP_COLOR_MAP } from '@/utils/groupColors'

/** Reserved: the current user's own messages, and the AI moderator's. */
export const SELF_BUBBLE = '#f7d4e2'
export const AGENT_BUBBLE = '#E6ECF1'

// Pastels at the same lightness as the two reserved colours. The first four are
// the room-group badge backgrounds. Slate is skipped — it reads as "no colour"
// and sits too close to AGENT_BUBBLE. Order matters: a two-person team, the
// common case, gets the two furthest apart.
const PARTICIPANT_BUBBLES = [
  GROUP_COLOR_MAP.amber.badgeBg,
  GROUP_COLOR_MAP.emerald.badgeBg,
  GROUP_COLOR_MAP.indigo.badgeBg,
  GROUP_COLOR_MAP.sky.badgeBg,
  '#ede9fe',
  '#ccfbf1',
]

/**
 * One colour per sender, keyed by id. Assigned over sorted ids rather than order
 * of appearance, so nobody's colour shifts when older history pages in.
 */
export function buildParticipantColors(
  messages: { sender_id?: number | null }[]
): Record<string, string> {
  const ids = [
    ...new Set(
      messages
        .map((m) => m.sender_id)
        .filter((id): id is number => id !== null && id !== undefined)
    ),
  ].sort((a, b) => a - b)

  return Object.fromEntries(
    ids.map((id, i) => [
      String(id),
      PARTICIPANT_BUBBLES[i % PARTICIPANT_BUBBLES.length],
    ])
  )
}
